(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4473],{

/***/ 26809:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/kundali",
      function () {
        return __webpack_require__(42626);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25889:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/line-gray.2a41f7c7.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEV7d3cA7s5HcEz/GDL/FC+MLzciAAAABXRSTlNhEACmbmR3WOMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVHicY2BgYGRhZmJgAAAANQALSowucwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 42626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ kundali; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/assets/images/ast-banner.jpg
/* harmony default export */ var ast_banner = ({"src":"/_next/static/media/ast-banner.657c795a.jpg","height":505,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAACAgMBAAAAAAAAAAAAAAAAEgECERQhMf/EABUBAQEAAAAAAAAAAAAAAAAAAAIE/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAIx/9oADAMBAAIRAxEAPwCRTe+orSreZ4ACq9F//9k="});
// EXTERNAL MODULE: ./src/assets/images/line-gray.png
var line_gray = __webpack_require__(25889);
// EXTERNAL MODULE: ./src/styles/astrokundali.module.scss
var astrokundali_module = __webpack_require__(72439);
var astrokundali_module_default = /*#__PURE__*/__webpack_require__.n(astrokundali_module);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
;// CONCATENATED MODULE: ./src/pages/astro/kundali/index.tsx








// Import Swiper styles


















var loadRazorpayScript = function() {
    return new Promise(function(resolve) {
        var script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = function() {
            return resolve(true);
        };
        script.onerror = function() {
            return resolve(false);
        };
        document.body.appendChild(script);
    });
};
var AstroKundali = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var authState = (0,react_redux_es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref3 = (0,react.useState)([]), state = ref3[0], setState = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), data = ref5[0], setData = ref5[1];
    var ref6 = (0,react.useState)([]), kundaliTypes = ref6[0], setKundaliTypes = ref6[1];
    var ref7 = (0,react.useState)(null), type = ref7[0], setType = ref7[1];
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            type_uuid: "",
            name: "",
            email: "",
            mobile: "",
            gender: "",
            place_of_birth: "",
            date_of_birth: "",
            time_of_birth: "",
            state: "",
            address: ""
        },
        validationSchema: es/* object */.Ry({
            state: es/* string */.Z_().required("State is required"),
            address: es/* string */.Z_().required("Address is required"),
            type_uuid: es/* string */.Z_().required("Type is required"),
            date_of_birth: es/* date */.hT().required("Date of birth is required").max(new Date(), "Date cannot be in the future"),
            time_of_birth: es/* string */.Z_().required("Time of birth is required"),
            name: es/* string */.Z_().required("Name is required").matches(/^[a-zA-Z\s]+$/, "Invalid name format"),
            gender: es/* string */.Z_().required("Gender is required"),
            email: es/* string */.Z_().email("Invalid email format").required(" Email is Required"),
            place_of_birth: es/* string */.Z_().required("Place of birth is required"),
            mobile: es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref, ref1, scriptLoaded, options, rzp1, ref2, ref3;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (authState.user) {
                                _ctx.next = 3;
                                break;
                            }
                            dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                            return _ctx.abrupt("return");
                        case 3:
                            setLoading(true);
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return http_client/* default.post */.Z.post(endpoints/* default.astro.bookKundaliv2 */.Z.astro.bookKundaliv2(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                time_of_birth: values.time_of_birth + ":00"
                            }));
                        case 7:
                            data = _ctx.sent.data;
                            if (window.smartech) {
                                ;
                                (0,unbxd/* unbxdCusEngTrackEvent */.$z)("kundli_form_filled", {
                                    type: (ref = kundaliTypes.find(function(v) {
                                        return v.uuid == values.type_uuid;
                                    })) === null || ref === void 0 ? void 0 : ref.name,
                                    amount: (ref1 = kundaliTypes.find(function(v) {
                                        return v.uuid == values.type_uuid;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.amount
                                });
                                window.smartech("identify", "".concat("91").concat(values.mobile));
                                (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                    "pk^mobile": "".concat("91").concat(values.mobile),
                                    email: values.email,
                                    NAME: values.name,
                                    GENDER: values.gender,
                                    SENCO_USER: "yes"
                                });
                            }
                            ;
                            if (!(data && data.params)) {
                                _ctx.next = 21;
                                break;
                            }
                            _ctx.next = 13;
                            return loadRazorpayScript();
                        case 13:
                            scriptLoaded = _ctx.sent;
                            if (!(!scriptLoaded || !window.Razorpay)) {
                                _ctx.next = 17;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Razorpay SDK failed to load");
                            return _ctx.abrupt("return");
                        case 17:
                            options = {
                                key: data.params.key,
                                amount: data.params.amount,
                                currency: data.params.currency,
                                name: data.params.name,
                                description: data.params.description,
                                image: data.params.image,
                                order_id: data.params.order_id,
                                callback_url: data.params.callback_url,
                                prefill: {
                                    name: data.params.prefill.name,
                                    email: data.params.prefill.email,
                                    contact: data.params.prefill.contact
                                },
                                notes: data.params.notes,
                                theme: {
                                    color: "#3399cc"
                                },
                                handler: function handler(response) {
                                    ;
                                    router.push("/astro/kundali/status/".concat(data.txnid));
                                },
                                modal: {
                                    ondismiss: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    router.push("/astro/kundali/status/".concat(data.txnid));
                                                case 1:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }))
                                }
                            };
                            if (window.Razorpay) {
                                rzp1 = new window.Razorpay(options);
                                rzp1.open();
                            } else {
                                setLoading(false);
                                (0,react_toastify_esm/* toast */.Am)("Razorpay SDK not available", {
                                    type: "error"
                                });
                            }
                            _ctx.next = 22;
                            break;
                        case 21:
                            {
                                window.location.href = data.redirect;
                            }
                        case 22:
                            _ctx.next = 28;
                            break;
                        case 24:
                            _ctx.prev = 24;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                            (0,react_toastify_esm/* toast */.Am)((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message) || "Something Went wrong", {
                                type: "warning"
                            });
                        case 28:
                            setLoading(false);
                        case 29:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        24
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var loadDetails = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.astro.kundaliTypes */.Z.astro.kundaliTypes());
                    case 3:
                        data = _ctx.sent.data;
                        setKundaliTypes(data);
                        formik.setFieldValue("type_uuid", data[0].uuid);
                        _ctx.next = 10;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadDetails() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadDetails();
        stateLoad("IND");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var stateLoad = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(country) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.state */.Z.state(country));
                    case 2:
                        data = _ctx.sent.data;
                        setState(data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function stateLoad(country) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (astrokundali_module_default()).astro_banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: ast_banner,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (astrokundali_module_default()).astro_banner_text,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container h_100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrokundali_module_default()).astro_banner_main,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (astrokundali_module_default()).astro_banner_main_text,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Life Kushti and Kundli Matching"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (astrokundali_module_default()).astrokundali_bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (astrokundali_module_default()).astrokundali_bg_main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (astrokundali_module_default()).heading,
                                children: [
                                    "GET FUTURE PREDICTIONS WITH ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "JANAM KUNDLI"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrokundali_module_default()).gline,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: line_gray/* default */.Z,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center mt-4 mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center",
                                            children: "Kundli is a success tool of life. Share with us the exact date and time of your birth and we will prepare your Janam Kundli (Life Kushti). An astrological chart representing the position of the Sun, Moon and other celestial bodies at the time of your birth. You can also choose from various types of Kundli services according to your specifications."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-center",
                                            children: [
                                                "Our customized ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "Kundli Matching"
                                                }),
                                                " services will help in determining your compatibility with your would-be spouse. You will get an in-depth analysis depending on the position of the planets in one’s horoscope. You can gain a deeper understanding of yourself, take informed decisions related to your financial career or navigate your relationship. Senco Gold & Diamonds has carved a niche in the industry by providing detailed Kundlis that give a better understanding of different life factors."
                                            ]
                                        })
                                    ]
                                })
                            }),
                            kundaliTypes && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: formik.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (astrokundali_module_default()).form_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (astrokundali_module_default()).heading_main_form,
                                                            children: "ENTER DETAILS"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "row check",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        children: [
                                                                            "Type Of Kundli",
                                                                            " ",
                                                                            formik.touched.type_uuid && formik.errors.type_uuid ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.type_uuid
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                !!kundaliTypes.length && kundaliTypes.map(function(v) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-4",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (astrokundali_module_default()).radio_card,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "row",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "col-md-6",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "form-check",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                        className: "form-check-input",
                                                                                                        type: "radio",
                                                                                                        checked: formik.values.type_uuid == v.uuid,
                                                                                                        onChange: function(e) {
                                                                                                            formik.setFieldValue("type_uuid", v.uuid);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                        className: "form-check-label",
                                                                                                        children: v.name
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "col-md-6 text-md-end",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                className: "ps-4 ps-md-0",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                                                    children: [
                                                                                                        " ",
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                                                                            value: v.amount
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    });
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: (astrokundali_module_default()).text_list,
                                                                        children: (ref2 = (ref = kundaliTypes.find(function(x) {
                                                                            return x.uuid == formik.values.type_uuid;
                                                                        })) === null || ref === void 0 ? void 0 : (ref1 = ref.info) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.map(function(type) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    children: type
                                                                                })
                                                                            });
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Name"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "text",
                                                                                className: "form-control",
                                                                                id: "exampleFormControlInput1",
                                                                                placeholder: "Name"
                                                                            }, formik.getFieldProps("name"))),
                                                                            formik.touched.name && formik.errors.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.name
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Email"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "email",
                                                                                className: "form-control",
                                                                                id: "exampleFormControlInput1",
                                                                                placeholder: "Email"
                                                                            }, formik.getFieldProps("email"))),
                                                                            formik.touched.email && formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.email
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Mobile Number"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "text",
                                                                                className: "form-control",
                                                                                placeholder: ""
                                                                            }, formik.getFieldProps("mobile"))),
                                                                            formik.touched.mobile && formik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.mobile
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Gender"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                className: "form-select"
                                                                            }, formik.getFieldProps("gender")), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "",
                                                                                        children: "Select"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "male",
                                                                                        children: "Male"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "female",
                                                                                        children: "Female"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "other",
                                                                                        children: "Other"
                                                                                    })
                                                                                ]
                                                                            })),
                                                                            formik.touched.gender && formik.errors.gender ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.gender
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Place of Birth"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "text",
                                                                                className: "form-control",
                                                                                id: "exampleFormControlInput1",
                                                                                placeholder: ""
                                                                            }, formik.getFieldProps("place_of_birth"))),
                                                                            formik.touched.place_of_birth && formik.errors.place_of_birth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.place_of_birth
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Date of Birth"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "date",
                                                                                className: "form-control",
                                                                                id: "exampleFormControlInput1",
                                                                                placeholder: ""
                                                                            }, formik.getFieldProps("date_of_birth"))),
                                                                            formik.touched.date_of_birth && formik.errors.date_of_birth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.date_of_birth
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: "Time of Birth"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "time",
                                                                                className: "form-control",
                                                                                id: "timeofbirth",
                                                                                placeholder: ""
                                                                            }, formik.getFieldProps("time_of_birth"))),
                                                                            formik.touched.time_of_birth && formik.errors.time_of_birth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.time_of_birth
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: [
                                                                                    "State / Province",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                className: "form-select"
                                                                            }, formik.getFieldProps("state")), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: "",
                                                                                        children: "Select"
                                                                                    }),
                                                                                    !!state.length && state.map(function(v) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                            value: v.code,
                                                                                            children: v.name
                                                                                        }, v.code);
                                                                                    })
                                                                                ]
                                                                            })),
                                                                            formik.touched.state && formik.errors.state ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.state
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                htmlFor: "exampleFormControlInput1",
                                                                                className: "form-label",
                                                                                children: [
                                                                                    "Address",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                type: "text",
                                                                                className: "form-control",
                                                                                placeholder: ""
                                                                            }, formik.getFieldProps("address"))),
                                                                            formik.touched.address && formik.errors.address ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.address
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-9"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-3 text-md-end",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        "aria-label": "Buy Now",
                                                                        className: (astrokundali_module_default()).appoint,
                                                                        disabled: loading,
                                                                        children: [
                                                                            "Buy Now",
                                                                            " ",
                                                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                animation: "border",
                                                                                size: "sm"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var kundali = (AstroKundali);


/***/ }),

/***/ 72439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"astro_banner":"astrokundali_astro_banner__r0nRv","astro_banner_text":"astrokundali_astro_banner_text__gsWv7","astro_banner_main":"astrokundali_astro_banner_main__Y8Z_O","astro_banner_main_text":"astrokundali_astro_banner_main_text__e7Apg","heading_main_form":"astrokundali_heading_main_form__xV6w8","appoint":"astrokundali_appoint__MJFBk","astrokundali_bg":"astrokundali_astrokundali_bg__cb36D","astrokundali_bg_main":"astrokundali_astrokundali_bg_main__yJXn3","heading":"astrokundali_heading__zIYXB","form_container":"astrokundali_form_container__cXs7M","form_select":"astrokundali_form_select__3s_gj","small_banner":"astrokundali_small_banner__Iy86y","choose_horoscope":"astrokundali_choose_horoscope__22cPx","custom_card":"astrokundali_custom_card__ImtsC","more":"astrokundali_more__5Iu36","wline":"astrokundali_wline__PzC3o","gline":"astrokundali_gline__gbK6C","about_astro":"astrokundali_about_astro__74fD6","about_astro_main":"astrokundali_about_astro_main__x9w6M","about_astro_main_img":"astrokundali_about_astro_main_img__PGtUz","about_astro_main_heading":"astrokundali_about_astro_main_heading__6gD37","about_astro_main_call":"astrokundali_about_astro_main_call__IypAi","call_number":"astrokundali_call_number__OChXX","horoscope_bg":"astrokundali_horoscope_bg__VIuqu","horoscope_bg_row":"astrokundali_horoscope_bg_row__GNSrr","horoscope_astro_head":"astrokundali_horoscope_astro_head__oeyZj","horoscope_bg_row_img":"astrokundali_horoscope_bg_row_img__wnQPI","horoscope_bg_row_img_heading":"astrokundali_horoscope_bg_row_img_heading__fyigc","horoscope_bg_row_button":"astrokundali_horoscope_bg_row_button__m0D_Q","horoscope_bg_row_form":"astrokundali_horoscope_bg_row_form__g0DTn","horoscope_bg_row_form_head":"astrokundali_horoscope_bg_row_form_head__DwQdw","horoscope_bg_row_form_body":"astrokundali_horoscope_bg_row_form_body__XS5gz","form_control":"astrokundali_form_control__PuCAc","red_button":"astrokundali_red_button__wwd87","horoscope_bg_row_w":"astrokundali_horoscope_bg_row_w__0hcc_","horoscope_bg_dark":"astrokundali_horoscope_bg_dark__lqAb2","horoscope_card":"astrokundali_horoscope_card__OxWOc","horoscope_card_head":"astrokundali_horoscope_card_head__cvd5b","text_card":"astrokundali_text_card__4zTAD","new_row_st":"astrokundali_new_row_st__qluuV","icon_container":"astrokundali_icon_container__5Z5sO","col":"astrokundali_col__QfOGu","icon_img":"astrokundali_icon_img__hRLF7","radio_card":"astrokundali_radio_card__zrOaq","text_change":"astrokundali_text_change__Q7m4V","text_list":"astrokundali_text_list__SycJr","card_border_new":"astrokundali_card_border_new__59TdO","price_form":"astrokundali_price_form__yfJ7A","price_cross_form":"astrokundali_price_cross_form__mUTuz","price_cross_form_save":"astrokundali_price_cross_form_save__tGmJR","card_head_new":"astrokundali_card_head_new__wrBXC","coupon_apply":"astrokundali_coupon_apply__SuWPw","w_166":"astrokundali_w_166__Z_quu","button_cross":"astrokundali_button_cross__tcn3r","button":"astrokundali_button__KIXVw","otp_resend":"astrokundali_otp_resend__Jzd31","line_head":"astrokundali_line_head__U__on"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(26809); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);